import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { LoadingScreen } from '../ui/LoadingScreen'

interface CreatePasswordRouteProps {
  children: React.ReactNode
}

export const CreatePasswordRoute: React.FC<CreatePasswordRouteProps> = ({
  children,
}) => {
  const { mustChangePassword, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingScreen message="Verificando autenticación..." />
  }

  if (!mustChangePassword) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

export default CreatePasswordRoute
